export enum EEnviroment {
  TEST = 'test',
  PROD = 'production',
}
